import { fetchWrapper } from "_helpers";

const baseUrl = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_CONTEXT_PATH}/warehouse`;

export const warehouseService = {
  getSuggestion,
  getById,
  getAll,
  create,
  update,
  delete: _delete,
  fetchWarehouseData,
  createBin,
  updateBin,
  deleteBin,
  getRacksByWarehouseId,
  getBinDetails,
};

function getSuggestion(params) {
  return fetchWrapper.get(`${baseUrl}/suggestion${params || ''}`);
}

function getById(id) {
  return fetchWrapper.get(`${baseUrl}/${id}`);
}

function getAll() {
  return fetchWrapper.get(baseUrl);
}

function create(params) {
  return fetchWrapper.post(baseUrl, params);
}

function update(id, params) {
  return fetchWrapper.put(`${baseUrl}/${id}`, params);
}

function _delete(id) {
  return fetchWrapper.delete(`${baseUrl}/${id}`);
}

// Fetch warehouse data by wmsId, rackId, binId, stockCategoryId, materialTypeId (Read)
function fetchWarehouseData(wmsId, rackId, binId, stockCategoryId, materialTypeId) {
  let url = `${baseUrl}`;
  const params = [];
  if (wmsId) params.push(`wmsId=${encodeURIComponent(wmsId)}`);
  if (rackId) params.push(`rackId=${encodeURIComponent(rackId)}`);
  if (binId) params.push(`binId=${encodeURIComponent(binId)}`);
  if (stockCategoryId) params.push(`stockCategoryId=${encodeURIComponent(stockCategoryId)}`);
  if (materialTypeId) params.push(`materialTypeId=${encodeURIComponent(materialTypeId)}`);
  if (params.length > 0) url += `?${params.join('&')}`;
  return fetchWrapper.get(url);
}

// Create a new bin (POST)
function createBin(wmsId, rackId, binData) {
  const url = `${baseUrl}/bin`;
  return fetchWrapper.post(url, { wmsId, rackId, ...binData });
}

// Update a bin (PUT)
function updateBin(binId, binData) {
  const url = `${baseUrl}/bin/${binId}`;
  return fetchWrapper.put(url, binData);
}

// Delete a bin (DELETE)
function deleteBin(binId) {
  const url = `${baseUrl}/bin/${binId}`;
  return fetchWrapper.delete(url);
}

// Fetch racks for a warehouse by warehouseId
function getRacksByWarehouseId(warehouseId) {
  return fetchWrapper.get(`${baseUrl}/${warehouseId}`);
}

// Fetch bin details by binId with pagination and mode
function getBinDetails(binId, pageNumber = 1, pageSize = 50, mode = 'AVAILABLE') {
  return fetchWrapper.get(`/api/stocks/bins?binId=${binId}&mode=${mode}&pageNumber=${pageNumber}&pageSize=${pageSize}`);
} 